import React from 'react';

const ManageCharacters = () => {
  return (
    <div className="page-content">
      <h2>Manage Characters</h2>
      <p>This is a dummy page for managing characters.</p>
    </div>
  );
};

export default ManageCharacters;
